import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { graphql, gql, compose } from 'react-apollo';

// Locale
import messages from '../../locale/messages';

import { isRTL } from '../../helpers/formatLocale';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BlogHomepageListings.css';
import cx from 'classnames';
import {
  Row
} from 'react-bootstrap';

// Component
import BlogHomepageCustomPagination from './BlogHomepageCustomPagination';
import BlogPostListingItem from './BlogPostListingItem';

// Config
import { blogPostsPerPage } from '../../config';

class BlogHomepageListings extends React.Component {
  static propTypes = {
    getBlogHomepageQuery: PropTypes.any
  };

  static defaultProps = {
    getBlogHomepageQuery: {
      loading: true,
      getBlogHomepage: {
        blogPosts: [],
        count: null
      }
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1
    };
    this.handlePagination = this.handlePagination.bind(this);
  }

  async handlePagination(currentPage, pageSize) {
    const { getBlogHomepageQuery: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ page:  currentPage});
    refetch(variables);
    window.scrollTo(0, 0);
  }

  render() {
    const { page } = this.state;
    const { getBlogHomepageQuery: { loading, getBlogHomepage }, locale } = this.props;

    if (!loading && getBlogHomepage != null && getBlogHomepage.blogPosts != null && getBlogHomepage.blogPosts.length > 0) {
      return (
        <div className={cx(s.searchResults, s.listItemOnly)}>
          {
            <Row className={s.noMargin}>
              <div className={cx(s.resultsContainer, 'resultsContainerRtl')}>
                {
                  getBlogHomepage.blogPosts.map((item, itemIndex) => {
                    return (
                      <div className={cx(s.listItem, s.displayInlineBlock)} key={item.id}>
                        <BlogPostListingItem
                          id={item.id}
                          pageUrl={item.pageUrl}
                          title={item.pageTitle}
                          date={item.createdAt}
                          description={item.metaDescription}
                          coverPhotoName={item.coverPhotoName}
                          locale={locale}
                          rtl={isRTL(locale)}
                        />
                      </div>
                    )
                  })
                }
              </div>
              <div className={s.resultsFooter}>
                <div className={s.resultsPagination}>
                  <div className={s.pagination}>
                    <BlogHomepageCustomPagination
                      total={getBlogHomepage.count}
                      current={page}
                      defaultCurrent={1}
                      defaultPageSize={blogPostsPerPage}
                      handleChange={this.handlePagination}
                    />
                  </div>
                </div>
              </div>
            </Row>
          }
        </div>
      );

    } else {
      return (
        <div>
          {
            loading && <div className={s.loadingOverlay} />
          }
          {
            loading && <p>Loading...</p>
          }
          {
            !loading && <p>No Results</p>
          }
        </div>
      );
    }
  }
}

export default injectIntl(withStyles(s)(BlogHomepageListings));


// WEBPACK FOOTER //
// src/components/BlogHomepageListings/BlogHomepageListings.js